import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminShell from "@/components/AdminShell";
import api from "@/lib/api";

const STATUSES = ["", "active", "expired", "revoked"];

export default function AdminComps() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("active");
  const [loading, setLoading] = useState(true);
  const [sortDir, setSortDir] = useState("asc");

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get(`/admin/comps${status ? `?status=${status}` : ""}`);
      setRows(r.data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    document.title = "Admin · Comps";
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const revoke = async (id) => {
    if (!window.confirm("Revoke this comp now?")) return;
    await api.post(`/admin/comps/${id}/revoke?reason=manual`);
    load();
  };

  const sorted = [...rows].sort((a, b) => {
    const av = a.expires_at || "";
    const bv = b.expires_at || "";
    return (sortDir === "asc" ? 1 : -1) * (av > bv ? 1 : -1);
  });

  return (
    <AdminShell>
      <div className="mb-6 flex items-end justify-between">
        <div>
          <div className="mono text-[10px] uppercase tracking-[0.22em] text-zinc-500">Comps</div>
          <h1 className="display mt-1 text-3xl font-black tracking-tight">
            {rows.length} {status || "all"}
          </h1>
        </div>
        <div className="flex items-center gap-2">
          {STATUSES.map((s) => (
            <button
              key={s || "all"}
              onClick={() => setStatus(s)}
              data-testid={`comp-filter-${s || "all"}`}
              className={`text-xs px-2 py-1 rounded-[3px] border ${
                status === s ? "bg-white text-black border-white" : "border-zinc-800 hover:bg-zinc-900"
              }`}
            >
              {s || "all"}
            </button>
          ))}
        </div>
      </div>

      <div className="bg-zinc-900/60 border border-zinc-800 rounded-[4px] overflow-hidden">
        <table className="w-full text-xs" data-testid="comps-table">
          <thead className="bg-zinc-900">
            <tr className="mono text-[10px] uppercase tracking-[0.22em] text-zinc-500">
              <th className="text-left p-2">User</th>
              <th className="text-left p-2">Plan</th>
              <th className="text-left p-2">Original</th>
              <th
                className="text-left p-2 cursor-pointer"
                onClick={() => setSortDir(sortDir === "asc" ? "desc" : "asc")}
                data-testid="sort-expiry"
              >
                Expires {sortDir === "asc" ? "↑" : "↓"}
              </th>
              <th className="text-left p-2">Reason</th>
              <th className="text-left p-2">Status</th>
              <th />
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800">
            {loading && (
              <tr>
                <td colSpan={7} className="p-3 text-center text-zinc-500">
                  Loading…
                </td>
              </tr>
            )}
            {!loading && sorted.length === 0 && (
              <tr>
                <td colSpan={7} className="p-3 text-center text-zinc-500">
                  None.
                </td>
              </tr>
            )}
            {sorted.map((c) => (
              <tr key={c.comp_id} data-testid={`comp-row-${c.comp_id}`}>
                <td className="p-2">
                  <Link
                    to={`/admin/users/${c.user_id}`}
                    className="hover:underline"
                  >
                    {c.user_email || c.user_id}
                  </Link>
                </td>
                <td className="p-2 capitalize">{c.comp_plan}</td>
                <td className="p-2 text-zinc-400 capitalize">{c.original_plan}</td>
                <td className="p-2 mono text-[10px] text-zinc-500">
                  {c.expires_at?.slice(0, 10)}
                </td>
                <td className="p-2 text-[11px]">{c.reason}</td>
                <td className="p-2 mono text-[10px] uppercase tracking-[0.14em]">
                  {c.status}
                </td>
                <td className="p-2 text-right">
                  {c.status === "active" && (
                    <button
                      onClick={() => revoke(c.comp_id)}
                      className="text-[10px] text-rose-300 hover:text-rose-400"
                      data-testid={`comp-revoke-${c.comp_id}`}
                    >
                      Revoke
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminShell>
  );
}
